<div *ngIf="mostrarCarrusel && slides && slides.length > 0">
    <ngx-slick-carousel id="slide-main" class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
        (init)="slickInit($event)" (afterChange)="afterChange($event)">

        <div ngxSlickItem *ngFor="let slide of slides" class="slide">

            <!-- Slide 1: banner de premios.
                 Antes aqui vivia el <video> de banner.mp4 (7.5 MB) con su
                 poster y el overlay2 que lo oscurecia. Se quitaron los tres:
                 lo que se ve ahora es el background-image del propio
                 #slider-awards (banner-home-2026.jpg), y el .row es el que
                 le da el alto por breakpoint. -->
            <!-- Toda la seccion es liga al micrositio (URL_MICROSITIO del
                 environment): el banner completo lleva a comprar. -->
            <a *ngIf="slide.id == 1" [href]="urlMicrositio" target="_blank" rel="noopener noreferrer">
                <section id="slider-awards" [style.background-image]="'url(' + slide.img.fondo + ')'">
                    <h1 class="sr-only"><span>Sorteo Anáhuac 11ª Edición</span></h1>
                    <div class="container-fluid p-0">
                        <div class="row no-gutters"></div>
                    </div>
                </section>
            </a>



            <!-- Slide 4: banner5 -->
            <section id="slider-banner5" *ngIf="slide.id == 4">
                <div class="banner5-lienzo">
                    <div class="container banner5-container">
                        <div class="row no-gutters align-items-center h-100">


                            <div class="col-12 col-lg-6 order-2 order-lg-1 banner5-figura">
                                <img [src]="slide.img.personas" alt="Sorteo Anáhuac" class="banner5-personas">
                            </div>

                            <!-- Derecha: texto y, debajo, el permiso SEGOB -->
                            <div class="col-12 col-lg-6 order-1 order-lg-2 banner5-copy">
                                <img [src]="slide.img.texto" alt="Sorteo Anáhuac" class="banner5-texto">

                                <!-- Permiso SEGOB: en el flujo, debajo de
                                     texto.png. Mismo trato que en banner7. -->
                                <div class="banner5-slide-permiso">
                                    PERMISO SEGOB EGRESADOS 20260126PS06
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>




            <!-- Slide 8: Ganadores del 1er Sorteo Oportuno. Modal
                 #modalTransmision, que era solo la imagen enlazada. -->
            <section id="slider-ganadores-so1" *ngIf="slide.id == 8">
                <div class="ganadores-so1-lienzo">
                    <a routerLink="/lista-ganadores-primer-sorteo-oportuno-2026" target="_blank"
                        class="ganadores-so1-link">
                        <img [src]="slide.img.imagen" class="ganadores-so1-img" alt="Ganadores del 1er Sorteo Oportuno">
                    </a>
                </div>
            </section>

            <!-- Slide 9: banner7. Mismo esquema que banner5 pero
                 espejeado: fondo.png de fondo, texto.png a la IZQUIERDA
                 y persona.png a la DERECHA. Apiladas (<992px) el orden
                 se invierte con order-*: primero el texto y abajo la
                 persona, igual que en los demas slides. -->
            <section id="slider-banner7" *ngIf="slide.id == 9">
                <div class="banner7-lienzo">
                    <div class="container-fluid banner7-container">
                        <div class="row no-gutters align-items-center h-100">

                            <!-- Izquierda: texto y, debajo, el permiso SEGOB -->
                            <div class="col-12 col-lg-6 order-1 banner7-copy">
                                <img [src]="slide.img.texto" alt="Sorteo Anáhuac" class="banner7-texto">

                                <!-- Permiso SEGOB: en el flujo, debajo de
                                     texto.png. Mismo trato que en banner2 y
                                     banner3. La columna lleva flex-column para
                                     que caiga abajo y no a un lado. -->
                                <div class="banner7-slide-permiso">
                                    PERMISO SEGOB 20260061PS09
                                </div>
                            </div>

                            <!-- Derecha: persona -->
                            <div class="col-12 col-lg-6 order-2 banner7-figura">
                                <img [src]="slide.img.persona" alt="Sorteo Anáhuac"
                                    class="banner7-persona d-md-block d-none">
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <!-- Slide 10: banner8, ganadores del Sorteo Egresados 2026.
                 Va al final del carrusel. fondo.png se pinta como
                 background del lienzo (atras, no como <img>) y encima
                 va un row de bootstrap partido en col-6 / col-6:
                 personas.png a la IZQUIERDA y texto.png a la DERECHA.
                 Apiladas (<992px) el order-* invierte el par para que
                 el texto quede arriba, igual que en los demas slides. -->
            <a routerLink="/lista-ganadores-sorteo-egresados-2026">
                <section id="slider-banner8" *ngIf="slide.id == 10">
                    <div class="banner8-lienzo" [style.background-image]="'url(' + slide.img.fondo + ')'">
                        <div class="container-fluid banner8-container">
                            <div class="row no-gutters align-items-center h-100">

                                <!-- Izquierda: personas -->
                                <div class="col-12 col-lg-6 order-2 order-lg-1 banner8-figura">
                                    <a [routerLink]="'/lista-ganadores-sorteo-egresados-2026'" target="_blank"
                                        rel="noopener noreferrer">
                                        <img [src]="slide.img.personas"
                                            alt="Ganadores del Sorteo Anáhuac Egresados 2026" class="banner8-personas">
                                    </a>
                                </div>

                                <!-- Derecha: texto y, al final, el permiso SEGOB -->
                                <div class="col-12 col-lg-6 order-1 order-lg-2 banner8-copy">
                                    <a [routerLink]="'/lista-ganadores-sorteo-egresados-2026'" target="_blank"
                                        rel="noopener noreferrer">
                                        <img [src]="slide.img.texto"
                                            alt="Conoce a los afortunados ganadores del Sorteo Egresados 2026"
                                            class="banner8-texto">
                                    </a>

                                    <!-- Permiso SEGOB: fuera del <a> (no es liga)
                                     y con width: 100% para que el flex-wrap de
                                     la columna lo baje a su propio renglón,
                                     debajo de texto.png. -->
                                    <div class="banner8-slide-permiso">
                                        PERMISO SEGOB: 20260126PS06
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </a>

            <!-- Slide 11: "Proximamente lista de ganadores del 3er
                 Sorteo Oportuno". fondo-lista-ganadores.png va de fondo
                 (en el scss). Grid de bootstrap col-6 / col-6:
                 izquierda la persona; derecha el logo negro y debajo el
                 banner de "Lista de ganadores". El permiso SEGOB va en
                 vertical, pegado a la orilla izquierda del slide. -->
            <section id="slider-ganadores-tercer" *ngIf="slide.id == 11">
                <div class="ganadores-tercer-lienzo">

                    <div class="ganadores-tercer-permiso">
                        PERMISO SEGOB 20260061PS09
                    </div>

                    <div class="container-fluid ganadores-tercer-container">
                        <div class="row no-gutters align-items-center h-100">

                            <!-- Izquierda: persona -->
                            <div class="col-12 col-lg-6 order-2 order-lg-1 ganadores-tercer-figura">
                                <img [src]="slide.img.persona" alt="Sorteo Anáhuac"
                                    class="ganadores-tercer-persona">
                            </div>

                            <!-- Derecha: logo y debajo el banner -->
                            <div class="col-12 col-lg-6 order-1 order-lg-2 ganadores-tercer-copy">
                                <img [src]="slide.img.logo" alt="Sorteos Anáhuac"
                                    class="ganadores-tercer-logo">
                                <img [src]="slide.img.banner"
                                    alt="Próximamente lista de ganadores del 3° Sorteo Oportuno. Se publicará el 24 de octubre"
                                    class="ganadores-tercer-banner">
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <!-- Slide 12: "Conoce a los afortunados ganadores del 3er
                 Sorteo Oportuno". Es el slide 11 espejeado:
                 fondo-lista-ganadores-tercero.png de fondo (en el scss),
                 izquierda el logo negro y debajo el texto; derecha la
                 persona. -->
            <section id="slider-afortunados" *ngIf="slide.id == 12">
                <!-- Todo el slide liga a la lista de ganadores del 3er
                     Sorteo Oportuno, igual que el slide de ganadores SO1. -->
                <a routerLink="/lista-ganadores-tercer-sorteo-oportuno-2026" target="_blank"
                    class="afortunados-lienzo">

                    <div class="afortunados-permiso">
                        PERMISO SEGOB:20260061PS09 / IMÁGENES ILUSTRATIVAS
                    </div>

                    <div class="container-fluid afortunados-container">
                        <div class="row no-gutters align-items-center h-100">

                            <!-- Izquierda: logo y debajo el texto -->
                            <div class="col-12 col-lg-6 order-1 afortunados-copy">
                                <img [src]="slide.img.logo" alt="Sorteos Anáhuac"
                                    class="afortunados-logo">
                                <img [src]="slide.img.texto"
                                    alt="¡Conoce a los afortunados ganadores del 3° Sorteo Oportuno! Visita www.sorteoanahuac.mx"
                                    class="afortunados-texto">
                            </div>

                            <!-- Derecha: persona -->
                            <div class="col-12 col-lg-6 order-2 afortunados-figura">
                                <img [src]="slide.img.persona" alt="Sorteo Anáhuac"
                                    class="afortunados-persona">
                            </div>

                        </div>
                    </div>
                </a>
            </section>

            <!-- Slide 13: "Unete a la transmision" del 3er Sorteo
                 Oportuno. fondo-ver-proximamente.png va de fondo (en el
                 scss). Grid col-6 / col-6: izquierda el texto; derecha
                 vacia, porque ahi el fondo ya trae la foto de las
                 tombolas. -->
            <section id="slider-transmision" *ngIf="slide.id == 13">
                <div class="transmision-lienzo">

                    <div class="transmision-permiso">
                        Permiso Segob:20260061PS09 / Imágenes ilustrativas.
                    </div>

                    <div class="container-fluid transmision-container">
                        <div class="row no-gutters align-items-center h-100">

                            <!-- Izquierda: texto -->
                            <div class="col-12 col-lg-6 transmision-copy">
                                <img [src]="slide.img.texto" alt="¡Únete a la transmisión!"
                                    class="transmision-texto">
                            </div>

                            <!-- Derecha: vacia -->
                            <div class="col-12 col-lg-6 transmision-figura"></div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    </ngx-slick-carousel>
</div>

<!-- Calle con los inmuebles del sorteo: clic en uno lleva a su recorrido (ver premios-calle) -->
<app-premios-calle></app-premios-calle>

<section id="lucky">
    <div class="container">
        <div class="row">

            <div class="col-12 text-center">
                <div class="overlap-signature">
                    <h2 class="main-text">Máquina</h2>
                    <span class="letter">de la <span class="signature-text">suerte</span></span>
                </div>
            </div>

            <!-- Con campaña activa: la fecha del sorteo sube como barra horizontal a todo el ancho -->
            <div class="col-md-12" *ngIf="showZod && info_zod.length > 0">
                <div class="fecha-bar">
                    <span class="fecha-bar__k">Descubre tu número</span>
                    <span class="fecha-bar__sep"></span>
                    <span class="fecha-bar__big">FECHA <span>DEL</span> SORTEO · 19 NOV 2026</span>
                    <span class="fecha-bar__sep"></span>
                    <span class="fecha-bar__price">Boleto $500</span>
                </div>
            </div>

            <!-- <div class="col-lg-6 col-md-12">
                <div class="content-machine">
                    <div class="text-center">
                        <img src="/assets/images/sorteo2025/aniversario.png" alt="Sorteo Anáhuac Aniversario"
                            class="img-fluid">
                    </div>
                    <div class="numbers-container aniv border-gradient-all box-s ">
                        <div class="numbers btn-gradient">
                            <ul id="list-n10">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>

                            </ul>
                        </div>
                        <div class="numbers btn-gradient">
                            <ul id="list-n11">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>
                        <div class="numbers btn-gradient">
                            <ul id="list-n12">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers btn-gradient">
                            <ul id="list-n13">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers btn-gradient">
                            <ul id="list-n14">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers btn-gradient">
                            <ul id="list-n15">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                    </div>

                    <div class="content text-center">
                        <div
                            class="buttons-generate d-flex justify-content-center align-items-center gap-3 mt-3 flex-column flex-lg-row">
                            <a *ngIf="!anivflag_buy" (click)="getBoletoRandomANIV();" class="btn-stack generate-number">
                                ¡Activa tu suerte aquí!
                            </a>

                            <a *ngIf="anivflag_buy_btn" (click)="sendTicketAniv();" class="btn-stack generate-number">
                                Comprar
                            </a>
                        </div>

                        <div *ngIf="anivflag_buy_loader" class="w-100 text-center mt-3">
                            <p>Generando tu número...</p>
                            <img src="/assets/images/sorteo2025/tickets.gif" class="img-fluid gif-ticket" width="170">
                        </div>

                    </div>

                </div>


            </div> -->



            <div class="col-lg-6 col-md-12 my-auto ">

                <div class="width-100 text-center" [class.disabled-tab]="flag_buy_loader"
                    (click)="!flag_buy_loader && getBoletoRandom()">

                    <div class="activate-tab btn-effect-pro">
                        <span class="activate">ACTIVAR</span>
                    </div>
                </div>

                <div class="content-machine magno-machine text-center mx-auto ">
                    <div class="text-center">
                        <img src="/assets/images/sorteo2026/logo-magno.png" alt="Sorteo Anáhuac Magno"
                            class="img-fluid mb-4" width="260">
                    </div>


                    <div class="numbers-container">
                        <div class="numbers num-magno">
                            <ul id="list-n0">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>

                            </ul>
                        </div>
                        <div class="numbers num-magno">
                            <ul id="list-n1">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>
                        <div class="numbers num-magno">
                            <ul id="list-n2">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers num-magno">
                            <ul id="list-n3">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers num-magno">
                            <ul id="list-n4">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                        <div class="numbers num-magno">
                            <ul id="list-n5">
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>
                                <li>0</li>
                                <li>1</li>
                                <li>2</li>
                                <li>3</li>
                                <li>4</li>
                                <li>5</li>
                                <li>6</li>
                                <li>7</li>
                                <li>8</li>
                                <li>9</li>


                            </ul>
                        </div>

                    </div>

                    <div class="content text-center">
                        <div class="buttons-generate">
                            <a *ngIf="!flag_buy" (click)="getBoletoRandom();"
                                class="btn-stack purple generate-number  mx-auto ">

                                ¡Activa tu suerte aquí!
                            </a>



                            <a *ngIf="flag_buy_btn" (click)="sendTicket();"
                                class="btn-stack purple generate-number  mx-auto">
                                Comprar
                            </a>

                        </div>

                        <div *ngIf="flag_buy_loader" class="w-100 text-center mt-3">
                            <p>
                                Generando tu número...
                            </p>
                            <img src="/assets/images/sorteo2025/tickets.gif" class="img-fluid gif-ticket" width="170">

                        </div>

                    </div>



                </div>




                <!-- <div class="prox">
                    <p>PRÓXIMAMENTE <p>
                </div> -->



            </div>



            <div class="col-lg-6 col-md-12 text-center">
                <!-- Sin campaña: la fecha vive aquí, al lado de la máquina -->
                <div class="content-head" *ngIf="!(showZod && info_zod.length > 0)">
                    <p class="title">Descubre tu número de la suerte</p>
                    <h4>FECHA <span>DEL</span> SORTEO</h4>
                    <p> 19 <span class="h-100 my-auto">.</span> nov <span>.</span> 2026</p>



                    <span class="price">
                        Boleto: $500
                    </span>

                </div>

                <!-- Campaña activa (SeleccionInformacionZodiaco) -->
                <div class="campania-inline" *ngIf="showZod && info_zod.length > 0">
                    <a [href]="urlMicrositio" target="_blank" rel="noopener noreferrer" class="campania-card">
                        <span class="campania-card__glow" aria-hidden="true"></span>

                        <!-- Preview tipo ventana del navegador -->
                        <span class="campania-card__preview">
                            <span class="campania-card__bar" aria-hidden="true">
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="dot"></span>
                                <span class="campania-card__url">
                                    <i class="fas fa-lock"></i> {{ urlMicrositio }}
                                </span>
                            </span>
                            <span class="campania-card__shot">
                                <img [src]="info_zod[0].IMAGEN_FONDO" alt="Vista previa de la campaña activa">
                                <span class="campania-card__badge">
                                    <span class="pulse"></span> Campaña activa
                                </span>
                                <span class="campania-card__shine" aria-hidden="true"></span>
                            </span>
                        </span>

                        <!-- Texto + CTA -->
                        <span class="campania-card__body">
                            <span class="campania-card__text">{{ info_zod[0].DESCRIPCION }}</span>
                            <span class="campania-card__cta">
                                Participar ahora
                                <i class="fas fa-arrow-right" aria-hidden="true"></i>
                            </span>
                        </span>
                    </a>
                </div>
            </div>




        </div>
    </div>
</section>


<section class="ours">
    <div class="container">
        <div class="row">
            <div class="col-xl-5 my-auto">

                <div class="overlap-signature">
                    <h2 class="main-text">Nuestros</h2>
                    <span class="letter"> <span class="signature-text">sorteos</span></span>
                </div>

            </div>
            <div class="col-xl-7 my-auto">
                <p>
                    Estamos cerca a celebrar nuestros Sorteos
                    y de conocer a los afortunados ganadores.

                    <span class="d-block mt-md-4">
                        Uno de ellos <strong>podrías ser tú.</strong>
                    </span>
                </p>
            </div>
        </div>
    </div>
</section>


<!-- <section id="counters-box-cta">
    <div class="container">
        <div class="row">


            <div class="col-12">
                <div class="content-img pt-5 pb-5">
                    <div class="row">


                        <div class="col-lg-5 my-auto text-center">
                            <img src="/assets/images/sorteo2025/img-56.png" class="img-fluid p-md-0  p-4">
                            <h5>Primer Premio</h5>
                            <p>
                                VALOR DE + DE 12.5 MILLONES DE PESOS
                            </p>
                            <p class="text-p">
                                DEPARTAMENTO <span>AMUEBLADO</span>
                                <span class="d-block" style="color: #000;"> EN CANCÚN</span>
                                <span class="d-block">BREZZA TOWERS MAR</span>
                            </p>
                        </div>


                        <div class="col-lg-4 offset-lg-3 my-auto text-center pt-3">
                            <img src="/assets/images/sorteo2025/logo-magno-card.png" class="img-fluid "
                                alt="Sorteo Anáhuac 2025" class="logo">

                            <a href="https://www.youtube.com/watch?v=GInQF_bUg6A" target="_blank"
                                class="btn-stack btn-sorteo-inside mt-4">
                                ¡REVIVE EL EN VIVO!
                            </a>


                        </div>
                    </div>
                </div>
            </div>


            <div class="col-lg-4">
                <div class="content-img oportuno1" style="height: 470px;">
                    <div class="header-top">
                        <h6>
                            1° SORTEO OPORTUNO
                        </h6>
                    </div>

                 
                    <div class="body-card">
                        <span>Primer premio</span>
                        <p>CHEQUE CERTIFICADO DE
                            <strong class="sg">$200,000.00</strong>
                        </p>
                        <p>
                            <strong style="color: #9d7fda; ">SEDE <span>UNIVERSIDAD ANÁHUAC MÉXICO CAMPUS NORTE</span>
                            </strong>
                        </p>

                    </div>

                    <div class="footer-card text-center w-100 mx-auto">
                        <p>
                            FECHA <span> <img src="/assets/images/sorteo2025/calendar-icon.png" alt="">23 MAY</span>
                        </p>
                    </div>

                </div>
            </div>

            <div class="col-lg-4">
                <div class="content-img oportuno2" style="height: 470px;">
                    <div class="header-top">
                        <h6>
                            2° SORTEO OPORTUNO
                        </h6>
                    </div>


                    <div class="body-card">
                        <span>Primer premio</span>
                        <p>CHEQUE CERTIFICADO DE
                            <strong class="sg">$200,000.00</strong>
                        </p>
                        <p>
                            <strong style="color: #ff8539;">SEDE <span>UNIVERSIDAD ANÁHUAC MÉXICO CAMPUS
                                    SUR</span></strong>
                        </p>

                    </div>


                    <div class="footer-card text-center w-100 mx-auto">
                        <p>
                            FECHA <span> <img src="/assets/images/sorteo2025/calendar-icon.png" alt="">22 AGO</span>
                        </p>
                    </div>

                </div>
            </div>

            <div class="col-lg-4">
                <div class="content-img oportuno3" style="height: 470px;">
                    <div class="header-top">
                        <h6>
                            3° SORTEO OPORTUNO
                        </h6>
                    </div>


                    <div class="body-card">
                        <span>Primer premio</span>
                        <p>CHEQUE CERTIFICADO DE
                            <strong class="sg">$200,000.00</strong>
                        </p>
                        <p>
                            <strong style="color:#e94a3c ;">SEDE <span>UNIVERSIDAD ANÁHUAC MÉXICO CAMPUS
                                    SUR</span></strong>
                        </p>

                    </div>
                    
                    <div class="footer-card text-center w-100 mx-auto">
                        <p>
                            FECHA <span> <img src="/assets/images/sorteo2025/calendar-icon.png" alt="">17 OCT</span>
                        </p>
                    </div>

                </div>
            </div>


        </div>
    </div>
</section> -->


<!-- <section class="flyer">
    <div class="container">
        <div class="row">
            <div class="col-12 mx-auto text-center">
                <img src="/assets/images/sorteo2026/flyer.jpg" alt="Sorteo Anáhuac Magno 2026" class="img-fluid w-100">
            </div>
        </div>
    </div>
</section> -->

<section class="sorteos-cta">
    <div class="container">
        <div class="row text-center justify-content-center">



            <div class="card-sorteo" style="width: 360px" routerLink="/sorteo-oportuno">
                <div class="card-header-assets">
                    <img class="esfera" src="/assets/images/sorteo2026/ball1.png">
                    <div class="img-wrapper">
                        <img class="img-principal" src="/assets/images/sorteo2026/banner-so1.png"
                            alt="Primer Sorteo Oportuno">
                        <div class="overlay-text">
                            <h5>SORTEO<br>OPORTUNO</h5>
                        </div>
                    </div>
                </div>

                <div class="card-body text-center">
                    <h6 class="premio-titulo m-0">Primer Premio</h6>
                    <p class="cheque-info m-0">CHEQUE CERTIFICADO DE</p>
                    <h4 class="monto">$250,000.00</h4>
                    <p class="sede-info">UNIVERSIDAD ANÁHUAC <br> MÉXICO CAMPUS NORTE</p>
                    <p class="fecha purple">FECHA: <span>22 MAY</span></p>
                </div>
            </div>



            <div class="card-sorteo" style="width: 360px" routerLink="/sorteo-oportuno">
                <div class="card-header-assets">
                    <img class="esfera" src="/assets/images/sorteo2026/ball2.png">
                    <div class="img-wrapper">
                        <img class="img-principal" src="/assets/images/sorteo2026/banner-so2-vf.png"
                            alt="Segundo Sorteo Oportuno">
                        <div class="overlay-text">
                            <h5>SORTEO<br>OPORTUNO</h5>
                        </div>
                    </div>
                </div>

                <div class="card-body text-center">
                    <h6 class="premio-titulo m-0">Primer Premio</h6>
                    <p class="cheque-info m-0">CHEQUE CERTIFICADO DE</p>
                    <h4 class="monto">$250,000.00</h4>
                    <p class="sede-info">UNIVERSIDAD ANÁHUAC <br> MÉXICO CAMPUS NORTE</p>
                    <p class="fecha orange">FECHA: <span>21 AGO</span></p>
                </div>
            </div>



            <div class="card-sorteo" style="width: 360px" routerLink="/sorteo-oportuno">
                <div class="card-header-assets">
                    <img class="esfera" src="/assets/images/sorteo2026/ball3.png">
                    <div class="img-wrapper">
                        <img class="img-principal" src="/assets/images/sorteo2026/banner-so3.png"
                            alt="Tercer Sorteo Oportuno">
                        <div class="overlay-text">
                            <h5>SORTEO<br>OPORTUNO</h5>
                        </div>
                    </div>
                </div>

                <div class="card-body text-center">
                    <h6 class="premio-titulo m-0">Primer Premio</h6>
                    <p class="cheque-info m-0">CHEQUE CERTIFICADO DE</p>
                    <h4 class="monto">$250,000.00</h4>
                    <p class="sede-info">UNIVERSIDAD ANÁHUAC <br> MÉXICO CAMPUS NORTE</p>
                    <p class="fecha red">FECHA: <span>23 OCT</span></p>
                </div>
            </div>




        </div>
    </div>
</section>




<section class="ours ">
    <div class="container">
        <div class="row">
            <div class="col-xl-6 my-auto">

                <div class="overlap-signature">
                    <h2 class="main-text">¡DESCUBRE TODO</h2>
                    <span class="letter" style="color: #ff5900;">lo que<span
                            class="signature-text ml-md-4">somos!</span></span>
                </div>

            </div>
            <div class="col-xl-6 my-auto">
                <p>
                    Explora nuestro propósito, conoce los increíbles premios que tenemos para ti, visita nuestro blog
                    lleno de historias inspiradoras y únete como colaborador para ser parte de algo más grande.

                    <span class="d-block mt-md-4">
                        ¡Hay <strong>mucho</strong> más <strong>por descubrir!</strong>
                    </span>
                </p>
            </div>
        </div>
    </div>
</section>

<section class="cta-buttons">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="cta-wrapper">
                    <img src="/assets/images/sorteo2026/cta-premios.jpg" alt="Premios Sorteo" class="img-main">
                    <div class="button-overlay">
                        <a routerLink="/premios-sorteo-anahuac" class="liquid-glass-btn">Premios</a>
                    </div>
                </div>
            </div>

        </div>

        <div class="row mt-4 secondary-ctas">

            <div class="col-md-4  mt-3 mb-3">
                <div class="cta-card glass-card">
                    <div class="card-content">
                        <h3>PRÓXIMAMENTE</h3>
                    </div>
                </div>
            </div>

            <div class="col-md-4 mt-3 mb-3" routerlink="/ganadores-sorteo">
                <a routerLink="/ganadores-sorteo" class="cta-card">
                    <img src="/assets/images/sorteo2026/ganadores.jpg" alt="Nuestros Ganadores">
                    <div class="card-overlay">
                        <h3>NUESTROS GANADORES</h3>
                    </div>
                </a>
            </div>

            <div class="col-md-4 mt-3 mb-3" routerlink="/premios-para-colaboradores">
                <a routerLink="/premios-para-colaboradores" class="cta-card">
                    <img src="/assets/images/sorteo2026/colaborador.jpg" alt="Premios Colaborador">
                    <div class="card-overlay">
                        <h3>PREMIOS COLABORADOR</h3>
                    </div>
                </a>
            </div>
        </div>


    </div>
</section>







<!-- <section id="counters">
    <div class="container-fluid ">
        <div class="row">
            <div class="col-12">
                <h5>Siguiente sorteo:

                </h5>
            </div>
            <div class="col-lg-6 col-12 d-md-flex justify-content-center line mt-xl-0 mt-5 text-center ">
             
                    <span class="sorteo-opt ">
                        <a [routerLink]="['/sorteo-oportuno']">
                            tercer 
                            sorteo 
                            oportuno
                        </a>
                    </span>
                
                <div class="counter border-gradient-all text-center mt-xl-0 mt-4">
                    <div class="number-count">
                        <span>{{ dias }}</span>.<span>{{ horas }}</span>.<span>{{ minutos }}</span>.<span>{{ segundos }}</span>
                    </div>

                    <div class="labels text-center">
                        <span>DÍAS</span>
                        <span>HRS</span>
                        <span>MIN</span>
                        <span>SEG</span>
                    </div>
                </div>
               
            </div> -->

<!-- <div class="col-xl-4 col-lg-6 col-12 d-md-flex justify-content-center line mt-xl-0 mt-5 text-center">
              
                    <span class="sorteo-opt  sorteo-egr">
                        <a [routerLink]="['/sorteo-egresado-universidad-anahuac']"> 
                            SORTEO
                            <span class="d-lg-block">
                                Egresados
                            </span> 
                        </a>
                    </span>
               
                
                <div class="counter border-gradient-all text-center mt-xl-0 mt-4">
                    <div class="number-count">
                        <span>{{ dias_egr }}</span>.<span>{{ horas_egr }}</span>.<span>{{ minutos_egr }}</span>.<span>{{ segundos_egr }}</span>
                    </div>

                    <div class="labels text-center">
                        <span>DÍAS</span>
                        <span>HRS</span>
                        <span>MIN</span>
                        <span>SEG</span>
                    </div>
                </div>
               
            </div> 


            <div class="col-12 d-md-flex justify-content-center mt-xl-0 mt-5 text-center">
                
                    <span class="sorteo-opt  sorteo-mg">
                       <a href="https://sorteoanahuaccompra.sorteoanahuac.mx/compra-en-linea-boletos-sorteo-anahuac{{urlUtm}}" target="_blank">
                            SORTEO MAGNO 
                            <span class="d-lg-block">
                               2024
                            </span>  
                        </a>
                    </span>
              
                <div class="counter border-gradient-all text-center mt-xl-0 mt-4">
                    <div class="number-count">
                        <span>{{ day }}</span>.<span>{{ hours }}</span>.<span>{{ minutes }}</span>.<span>{{ seconds }}</span>
                        <span>¡PRÓXIMAMENTE!</span>
                    </div>

                    <div class="labels text-center">
                        <span>DÍAS</span>
                        <span>HRS</span>
                        <span>MIN</span>
                        <span>SEG</span>
                    </div>
                </div>
               
            </div>

           

        </div>
    </div>
</section> -->

<!-- 

<section id="parthers">
    <div class="container-fluid">
        <div class="row">

            <div class="col-md-12 text-center">
                <div class="overlap-signature">
                    <h2 class="main-text">Nuestros</h2>
                    <span class="letter"><span class="signature-text">aliados</span></span>
                </div>
            </div>

            <div class="col-md-12 text-center">


                <a href="https://www.mini.com.mx/" target="_blank">
                    <img src="/assets/images/sorteo2026/mini.png" class="img-fluid" width="100" alt="Mini Cooper">
                </a>

                <a href="https://www.audi.com.mx/" target="_blank">
                    <img src="/assets/images/sorteo2026/audi.png" class="img-fluid" width="100" alt="Audi">
                </a>


                <a href="https://www.kia.com/mx/main.html" target="_blank">
                    <img src="/assets/images/sorteo2026/kia.png" class="img-fluid" alt="Kia">
                </a>


                <a href="https://www.brezza.mx/" target="_blank">
                    <img src="/assets/images/sorteo2026/brezza.png" class="img-fluid" alt="BREZZA"
                        style="filter: brightness(1);">
                </a>

                <a href="https://www.bosquereal.com.mx/blue/" target="_blank">
                    <img src="/assets/images/sorteo2026/blue.png" class="img-fluid" alt="Blue Bosque Real">
                </a>

                <a href="https://loredi.com.mx/" target="_blank">
                    <img src="/assets/images/sorteo2026/loredi.png" class="img-fluid" alt="Loredi">
                </a>



                <a href="https://www.paypal.com/mx/home" target="_blank">
                    <img src="/assets/images/sorteo2025/aliado8.png" class="img-fluid" alt="">
                </a>




            </div>
        </div>
    </div>
</section> -->


<!-- 
<section class="news">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="input-group">
                    <div class="label-container">Newsletter</div>
                    <div class="input-wrapper">
                        <input type="text" placeholder="Tu correo aquí">
                        <button type="button">SUSCRIBIR</button>
                    </div>
                </div>
                <p>
                    Recibe promociones exclusivas, noticias destacadas y las actualizaciones más recientes de nuestro
                    blog directamente en tu correo.
                </p>
                <div class="checkbox-group">
                    <input type="radio" id="terms">
                    <small>He leído y acepto los términos y condiciones y las políticas de privacidad</small>
                </div>
            </div>
        </div>
    </div>
</section> -->

<!-- ===== MODALES ELIMINADOS =====
     Aqui vivian los cinco modales de bienvenida del home:
       #modalEgresados      (egresados, el que abria primero)
       #modalTransmision    (ya venia comentado)
       #unete-transmision   ("Unete a la transmision")
       #banner2             (2do Sorteo Oportuno)
       #banner3             (ganadores del 2do Sorteo Oportuno)
     Se quitaron junto con sus @ViewChild, sus banderas mostrarModal* y
     los metodos abrirModal* / cerrarModal del componente.

     Su contenido se reacomodo como slides del carrusel de arriba.
     #slider-unete, #slider-banner2 y #slider-banner3 ya se borraron
     (junto con sus objetos del array `slides`); #slider-ganadores-so1
     sigue en este archivo aunque hoy no se renderiza.

     Por eso los estilos de esos modales SIGUEN en src/sass/_home.scss:
     los slides reusan las mismas clases (.modal-egresados-bg,
     .unete-*, .banner2-*, .banner3-*, .banner-permiso). Borrarlos
     romperia los slides si algun dia se reviven.

     El modal de login (#loginmodal) no vive aqui: esta en el header
     compartido y lo usan tambien menu-login y recuperar-pass. -->